//import DeleteIcon from '@mui/icons-material/Delete';
import {default as DeleteIcon} from '@mui/icons-material/DeleteOutline';

export default DeleteIcon;